/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";

// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";

// Dashboard layout components
import BuildByDevelopers from "layouts/dashboard/components/BuildByDevelopers";
import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
import Projects from "layouts/dashboard/components/Projects";
import OrderOverview from "layouts/dashboard/components/OrderOverview";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboard/data/gradientLineChartData";
import {authTotalCustomer,authTotalApprovedCustomer,authTotalRejectedCustomer,authTotalPendingCustomer} from '../../assets/globalAPI/GlobalApi';
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import { fetchDashboard } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
function Dashboard() {
  const navigate = useNavigate();
  const { size } = typography;
  const { chart, items } = reportsBarChartData;
  const[userid,setUserID] = useState('');
  const[user_type,setUserType] = useState('');
  const [isActive,setIsActive]= useState(false)
  const[totalCustomer,setTotalCustomer] = useState('');
  const[totalApprovedCustomer,setTotalApprovedCustomer] = useState('');
  const[totalRejectedCustomer,setTotalRejectedCustomer] = useState('');
  const[totalPendingCustomer,setTotalPendingCustomer] = useState('');
  const [dashData,setDashData]= useState({});
  // useEffect(() => {
  //   if (localStorage.getItem('userid_details')) { 
  //   let session = localStorage.getItem('userid_details');
  //     let userid_array =JSON.parse(session);
  //     let userid = userid_array.userid;
  //     let user_type = userid_array.user_type;
  //     setUserID(userid);
  //     setUserType(user_type);
  //   }
    
  //   const total_cus_data = {
  //     "action": 'getCustomerCount',
  //     "userid" : userid,
  //     "user_type" : user_type
  //   };

  //   const approved_cus_data = {
  //     "action": 'getApprovedCustomerCount',
  //     "userid" : userid,
  //     "user_type" : user_type
  //   };

  //   const rejected_cus_data = {
  //     "action": 'getRejectedCustomerCount',
  //     "userid" : userid,
  //     "user_type" : user_type
  //   };

  //   const pending_cus_data = {
  //     "action": 'getPendingCustomerCount',
  //     "userid" : userid,
  //     "user_type" : user_type
  //   };
    
  //   authTotalCustomer(JSON.stringify(total_cus_data)).then(function(response) {
  //   var res = response.data;
   
  //     if(res.status=='true' && res.code=='200')
  //     {
  //       setTotalCustomer(res.total_creation);
  //     }else{
  //       setTotalCustomer(res.total_creation);
  //   }
  //   }.bind(this)
  // )
  // .catch(function(error) {
  // console.log(error);
  
  // });

  // authTotalApprovedCustomer(JSON.stringify(approved_cus_data)).then(function(response) {
  //   var res = response.data;
  //     if(res.status=='true' && res.code=='200')
  //     {
  //       setTotalApprovedCustomer(res.count);
  //     }else{
  //       setTotalApprovedCustomer(res.count);
  //   }
  //   }.bind(this)
  // )
  // .catch(function(error) {
  // console.log(error);
  
  // });

  // authTotalRejectedCustomer(JSON.stringify(rejected_cus_data)).then(function(response) {
  //   var res = response.data;
  //     if(res.status=='true' && res.code=='200')
  //     {
  //       setTotalRejectedCustomer(res.count);
  //     }else{
  //       setTotalRejectedCustomer(res.count);
  //   }
  //   }.bind(this)
  // )
  // .catch(function(error) {
  // console.log(error);
  
  // });

  // authTotalPendingCustomer(JSON.stringify(pending_cus_data)).then(function(response) {
  //   var res = response.data;
  //     if(res.status=='true' && res.code=='200')
  //     {
  //       setTotalPendingCustomer(res.count);
  //     }else{
  //       setTotalPendingCustomer(res.count);
  //   }
  //   }.bind(this)
  // )
  // .catch(function(error) {
  // console.log(error);
  
  // });
  
  
  // },[userid]);

  useEffect(()=>{
    const myUser= JSON.parse(localStorage.getItem("userdetails"));
    // setUserID(myUser.id)
    fetchDashboardData(myUser.id)
  },[])

  const fetchDashboardData=async(id)=>{
    setIsActive(true)
    const body={
      userId:id
    }
                  try{
                    const response= await fetchDashboard(body);
                    const res= response.data;
                    if(res.status){
                      setDashData(res.data)
                      setIsActive(false)
                      // setKdsData3(res.data)
                      // setCustTitle(res.data.title)
                      console.log("dashboard data fetched>> ", res.data);
                    }else{
                      setDashData({})
                      setIsActive(false)
                      console.log("could not bring dashboard data>> ", res)
                    }
                  }catch(error){
                    setDashData({})
                    setIsActive(false)
                    console.log("error bringing dahsboard data>> ", error);
                     if(error.response?.status==403){
                                          if(!toast.isActive(toastId.current)){
                                            toastId.current= toast.error("Your Session has expired",{
                                              className:"small-toast"
                                            })
                                          }
                                          setTimeout(()=>{
                                            navigate("/")
                                            localStorage.clear();
                                          },2000)
                                          return;
                                        }
                  }
                }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SimpleBackdrop openLoader={isActive}/>
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "total customer" }}
                // percentage={{ color: "success", text: "+55%" }}
                icon={{ color: "info", component: "groups" }}
                count={dashData?.total_customer}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "total vendor" }}
                count={dashData?.total_vendor}
                // percentage={{ color: "success", text: "+3%" }}
                icon={{ color: "success", component: "store" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "total material" }}
                count={dashData?.total_material}
                // percentage={{ color: "error", text: "-2%" }}
                icon={{ color: "error", component: "inventory" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "pending approvals" }}
                count={dashData?.total_pending_approval}
                // percentage={{ color: "success", text: "+5%" }}
                icon={{
                  color: "warning",
                  component: "hourglass_top",
                }}
              />
            </Grid>
          </Grid>
        </SoftBox>
        {/* <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <BuildByDevelopers />
            </Grid>
            <Grid item xs={12} lg={5}>
              <WorkWithTheRockets />
            </Grid>
          </Grid>
        </SoftBox> */}
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} lg={5}>
              <ReportsBarChart
                title="active users"
                description={
                  <>
                    (<strong>+23%</strong>) than last week
                  </>
                }
                chart={chart}
                items={items}
              />
            </Grid> */}
            {/* <Grid item xs={12} lg={7}>
              <GradientLineChart
                title="Customer Account Group wise Customer creation"
                description={
                  <SoftBox display="flex" alignItems="center">
                    <SoftBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                      <Icon className="font-bold">arrow_upward</Icon>
                    </SoftBox>
                    <SoftTypography variant="button" color="text" fontWeight="medium">
                      4% more{" "}
                      <SoftTypography variant="button" color="text" fontWeight="regular">
                        in 2021
                      </SoftTypography>
                    </SoftTypography>
                  </SoftBox>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              />
            </Grid> */}
          </Grid>
        </SoftBox>
        {/* <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <Projects />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <OrderOverview />
          </Grid>
        </Grid> */}
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
